import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {useTimelineNewStore} from '@components/timeline-new/timeline-new-store'
import {cn} from '@containers/html-utils'
import {Cutoffs} from './cutoffs'

const TwMeasure = tw.div`
  flex
  flex-col
  shadow-border-b-1
  shadow-line-base
`

const TwCutoffs = tw(Cutoffs)`
  flex-none
  pointer-events-none
  select-none
`

export interface MeasureProps {
  className?: string
}

export const Measure = observer((props: MeasureProps) => {
  const {className} = props
  const [state] = useTimelineNewStore()

  return (
    <TwMeasure
      className={cn(className, state.showDiagramShadow && 'shadow-sm')}
    >
      <TwCutoffs cutoffs={state.cutoffsTop} type="top" />
      <TwCutoffs cutoffs={state.cutoffsBottom} type="bottom" />
    </TwMeasure>
  )
})
